// define filters to be used in templates: {{ value | filterName(arg1,arg2) }}
// or programmatically: this.$options.filters.filterName(value, ...);
// -----------
// https://vuejs.org/v2/guide/syntax.html#Filters

import moment from 'moment'
import productService from '../service/ProductService'
import Vue from 'vue'
import isNil from 'lodash/isNil'

// PERCENT
//
Vue.filter('percent', (value, forceSign) => {
  if (isNil(value)) {
    return '—'
  }
  let sign = forceSign && value > 0 ? '+' : ''
  return sign + value.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3
  }) + '&nbsp;%'
})

// CURRENCY
//
Vue.filter('currency', (value, currencyUnit, maximumFractionDigits = 2) => {
  if (isNil(value)) {
    return '—'
  }
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits
  }) + '&nbsp;' + currencyUnit
})

// DATE
//
Vue.filter('date', (value, format) => {
  if (isNil(value)) {
    return '—'
  }
  if (format && format.includes(':')) {
    format += ' [Uhr]'
  }

  return moment(value).format(format || 'DD.MM.YYYY')
})

// UNIX DATE
//
Vue.filter('unixDate', (value, format) => {
  if (isNil(value)) {
    return '—'
  }
  return moment.unix(value).format(format || 'DD.MM.YYYY')
})

// STOCK EXCHANGE
//
Vue.filter('stockExchange', (value) => {
  if (isNil(value)) {
    return '—'
  }
  return productService.stockmarketMap[value]
})

// SETTLEMENT
//
Vue.filter('settlement', (value) => {
  if (isNil(value)) {
    return '—'
  }
  return value === 'CASH'
    ? 'Barausgleich'
    : 'Physisch'
})




// WEBPACK FOOTER //
// ./src/core/Filters.js